import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../../services/forms/form-cocina.service'

@Component({
  selector: 'app-dialog-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dialog-menu.component.html',
  styleUrls: ['./dialog-menu.component.scss']
})
export class DialogMenuComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  menuForm
  constructor (
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly formService: FormCocinaService,
    private readonly alimentosService: AyBService,
    public dialogRef: MatDialogRef<DialogMenuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.menuForm = this.fb.group({
      menu: this.formService.getMenuForm()
    })
  }

  ngOnInit (): void {
    //console.log(this.dishForm.get('dish.nombre')?.value);
    this.menuForm.get(['menu', 'nombre'])?.setValue(this.data.nombre)
    this.menuForm.get(['menu', 'descripcion'])?.setValue(this.data.descripcion)
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  createMenu () {
    if (this.menuForm.get(['menu', 'nombre'])?.value) {
      const menu = {
        nombreMenu: this.menuForm.value.menu?.nombre,
        descripcion: this.menuForm.value.menu?.descripcion
      }
      console.log({
        menu
      })
      this.alimentosService
        .mutationCreateMenu(menu)
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe(data => {
          console.log('newMenu')
          console.log(data)
          this.navigateToDetalleMenu(data.createMenu.id)
          this.dialogRef.close(1)
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'Falta ingresar campos requeridos',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  navigateToDetalleMenu (menuId: number) {
    this.router
      .navigate([`/detalle-menu/${menuId}`])
      .then(() => console.log('Navigated to Detalle Menu'))
  }
}
